import { render, staticRenderFns } from "./StreamerCampaigns.vue?vue&type=template&id=5fc6de9f&scoped=true&"
import script from "./StreamerCampaigns.vue?vue&type=script&lang=js&"
export * from "./StreamerCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./StreamerCampaigns.vue?vue&type=style&index=0&id=5fc6de9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6de9f",
  null
  
)

export default component.exports